import { types } from 'mobx-state-tree';

const CompanyMetadataProps = {
  hasProspectingContacts: types.optional(types.maybeNull(types.boolean), null),
  hasProspectingContactsCount: types.optional(types.maybeNull(types.number), null),
  companyScore: types.optional(types.maybeNull(types.number), null),
  partialCompany: types.optional(types.maybeNull(types.boolean), null),
};

const CompanyMetadata = types.model(CompanyMetadataProps);

export default CompanyMetadata;

